if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  const register = () => {
    Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: false,
        loaded: [0],
        init() {
          this.currentTab = 1;
          this.loading = false;
          this.syncTabPanels();
          this.syncTabLabels();
        },
        select(index) {
          this.currentTab = index;
          this.syncTabPanels();
          this.syncTabLabels();
        },
        syncTabPanels() {
          container.querySelectorAll('[id^="x-fc-"]').forEach((tab) => {
            const match = tab.id.match(/-(\d+)$/);
            const tabIndex = match ? Number(match[1]) : 0;
            if (tabIndex === this.currentTab) {
              tab.style.removeProperty('display');
            } else {
              tab.style.setProperty('display', 'none', 'important');
            }
          });
        },
        syncTabLabels() {
          container.querySelectorAll('.collection-title [class*="label-"]').forEach((label, i) => {
            if ((i + 1) === this.currentTab) {
              label.classList.add('active');
            } else {
              label.classList.remove('active');
            }
          });
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                if (typeof initAlpineMount === 'function') {
                  initAlpineMount(newContent);
                } else if (window.Alpine?.initTree && !newContent._x_dataStack?.length) {
                  Alpine.initTree(newContent);
                }
                this.loaded.push(selectedPage);
              }
              this.loading = false;
              this.syncTabPanels();
              this.syncTabLabels();
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
  };

  if (window.__onAlpineInit) {
    window.__onAlpineInit(register);
  } else if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }
}